import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import PrivateRoute from '../components/auth/PrivateRoute';
import DesktopOnly from '../components/common/DesktopOnly';

const LandingPage = lazy(() => import('../pages/landing/page'));
const AuthPage = lazy(() => import('../pages/auth/index'));
const LoginPage = lazy(() => import('../pages/auth/Login'));
const RegisterPage = lazy(() => import('../pages/auth/Register'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/ForgotPassword'));
const ResetPasswordPage = lazy(() => import('../pages/auth/ResetPassword'));
const VerifyEmailPage = lazy(() => import('../pages/auth/VerifyEmail'));
const OAuthSuccessPage = lazy(() => import('../pages/auth/OAuthSuccess'));
const HomePage = lazy(() => import('../pages/home/page'));
const FactorLibraryPage = lazy(() => import('../pages/factor-library/page'));
const FactorWorkbenchPage = lazy(() => import('../pages/factor-library/page')); // 因子工作台（与因子库共用页面）
const FactorRunDetailPage = lazy(() => import('../pages/factor-library/detail'));
const FactorDevelopmentPage = lazy(() => import('../pages/factor-development/page'));
const BacktestPage = lazy(() => import('../pages/backtest/page'));
const StrategyWorkbenchPage = lazy(() => import('../pages/strategy-workbench/page'));
const ReportCenterPage = lazy(() => import('../pages/report-center/page'));
const StockQueryPage = lazy(() => import('../pages/stock-query/page'));
const MonitoringPage = lazy(() => import('../pages/monitoring/page'));
const BatchExperimentsPage = lazy(() => import('../pages/batch-experiments/page'));
const RecommendationsPage = lazy(() => import('../pages/recommendations/page'));
const AnalystPage = lazy(() => import('../pages/analyst/page'));
const MyPortfolioPage = lazy(() => import('../pages/my-portfolio/page'));
const HelpPage = lazy(() => import('../pages/help/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/auth/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/auth/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/auth/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '/auth/oauth-success',
    element: <OAuthSuccessPage />,
  },
  {
    path: '/app',
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/app/recommendations" replace />,
      },
      {
        path: 'chat',
        element: <HomePage />,
      },
      {
        path: 'factor-workbench',
        element: <DesktopOnly title="因子工作台"><FactorWorkbenchPage /></DesktopOnly>,
      },
      {
        path: 'factor-library',
        element: <DesktopOnly title="因子库"><FactorLibraryPage /></DesktopOnly>, // 保留作为兼容路由
      },
      {
        path: 'factor-library/:factorId',
        element: <DesktopOnly title="因子详情"><FactorRunDetailPage /></DesktopOnly>,
      },
      {
        path: 'factor-library/:factorId/run/:runId',
        element: <DesktopOnly title="回测详情"><FactorRunDetailPage /></DesktopOnly>,
      },
      {
        path: 'factor-development',
        element: <DesktopOnly title="因子开发"><FactorDevelopmentPage /></DesktopOnly>, // 保留作为兼容路由
      },
      {
        path: 'backtest',
        element: <DesktopOnly title="回测"><BacktestPage /></DesktopOnly>, // 保留作为兼容路由
      },
      {
        path: 'strategy-workbench',
        element: <DesktopOnly title="策略工作台"><StrategyWorkbenchPage /></DesktopOnly>,
      },
{
        path: 'report-center',
        element: <DesktopOnly title="报告中心"><ReportCenterPage /></DesktopOnly>,
      },
      {
        path: 'stock-query',
        element: <DesktopOnly title="个股查询"><StockQueryPage /></DesktopOnly>,
      },
{
        path: 'monitoring',
        element: <DesktopOnly title="监控面板"><MonitoringPage /></DesktopOnly>,
      },
      {
        path: 'batch-experiments',
        element: <DesktopOnly title="批量实验"><BatchExperimentsPage /></DesktopOnly>,
      },
      {
        path: 'recommendations',
        element: <RecommendationsPage />,
      },
      {
        path: 'my-portfolio',
        element: <MyPortfolioPage />,
      },
      {
        path: 'analyst',
        element: <DesktopOnly title="研报研究"><AnalystPage /></DesktopOnly>,
      },
      {
        path: 'help',
        element: <HelpPage />,
      },
      {
        path: 'home',
        element: <Navigate to="/app/recommendations" replace />,
      },
    ],
  },
  // Legacy routes redirect
  {
    path: '/factor-library',
    element: <Navigate to="/app/factor-library" replace />,
  },
  {
    path: '/factor-development',
    element: <Navigate to="/app/factor-development" replace />,
  },
  {
    path: '/backtest',
    element: <Navigate to="/app/backtest" replace />,
  },
{
    path: '/report-center',
    element: <Navigate to="/app/report-center" replace />,
  },
  {
    path: '/stock-query',
    element: <Navigate to="/app/stock-query" replace />,
  },
{
    path: '/monitoring',
    element: <Navigate to="/app/monitoring" replace />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
